"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var date_fns_1 = require("date-fns");
var date_util_1 = require("@hikakaku/shared/util/date_util");
var LOCAL_STORAGE_KEY_BASE = "estimate_fuyo_reentry_modal_";
var DATE_FORMAT = "yyyyMMdd HH:mm:ss";
var ENDPOINT = "/users/estimates/entries/:entryId/fuyo_reentries/";
var EstimateFuyoReentryModalStore = /** @class */ (function () {
    function EstimateFuyoReentryModalStore(_a) {
        var authenticityToken = _a.authenticityToken, originalEntryId = _a.originalEntryId, isOpen = _a.isOpen;
        var _this = this;
        this.handleClose = function () {
            _this.isOpen = false;
        };
        this.open = function () {
            if (_this.hidePeriodExpired) {
                _this.isOpen = true;
            }
        };
        this.isHidePeriodExpired = function (lastOpenedAt) {
            return (0, date_util_1.isHidePeriodExpired)(lastOpenedAt);
        };
        this.authenticityToken = authenticityToken;
        this.originalEntryId = originalEntryId;
        var key = LOCAL_STORAGE_KEY_BASE + originalEntryId;
        (0, mobx_1.autorun)(function () {
            if (_this.isOpen) {
                localStorage.setItem(key, (0, date_fns_1.format)(new Date(), DATE_FORMAT));
            }
        });
        var lastOpenedAt = localStorage.getItem(key);
        this.hidePeriodExpired = !lastOpenedAt || this.isHidePeriodExpired(lastOpenedAt || '');
        this.isOpen = isOpen && this.hidePeriodExpired;
    }
    Object.defineProperty(EstimateFuyoReentryModalStore.prototype, "endpoint", {
        get: function () {
            return ENDPOINT.replace(':entryId', this.originalEntryId.toString());
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], EstimateFuyoReentryModalStore.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], EstimateFuyoReentryModalStore.prototype, "endpoint", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EstimateFuyoReentryModalStore.prototype, "handleClose", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EstimateFuyoReentryModalStore.prototype, "open", void 0);
    return EstimateFuyoReentryModalStore;
}());
exports.default = EstimateFuyoReentryModalStore;
